import { render, staticRenderFns } from "./ContactSearches.vue?vue&type=template&id=454274e2&"
import script from "./ContactSearches.vue?vue&type=script&lang=js&"
export * from "./ContactSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports